import { createSelector } from '@reduxjs/toolkit'
import { CheckoutAppSelector, useAppSelector } from '..'
import { ProcessingState } from './reducer'

export const processingSelector: CheckoutAppSelector<ProcessingState> = (state) => state.processing

export const displayProcessingModalSelector: CheckoutAppSelector<boolean> = createSelector(processingSelector, (state) => state.displayProcessingModal)

export const sendEndTransactionMessageSelector: CheckoutAppSelector<boolean | undefined> = createSelector(
  processingSelector,
  (state) => state.sendEndTransactionMessage
)

export const useProcessing = (): ProcessingState => useAppSelector(processingSelector)

export const useDisplayProcessingModal = (): boolean => useAppSelector(displayProcessingModalSelector)

export const useSendEndTransactionMessage = (): boolean | undefined => useAppSelector(sendEndTransactionMessageSelector)
